module.exports = __webpack_public_path__ + "img/notes-purple.7c03e2a0.svg";